import React from "react";
import { Button, Layout, Typography } from "antd";
import { Edit, Copy, EyeOff, Eye, Save } from "lucide-react";
import { colors } from "../../config/constants";

/**
 * Pure view component for the project page header.
 * Receives all data and callbacks from the parent (orchestrator).
 */
const ProjectHeader = ({
  projectName = "Unnamed Project",
  isEditing = false,
  saving = false,
  hasFormErrors = false,
  validating = false,
  showPreview = false,
  onEdit,
  onCancelEdit,
  onSave,
  onValidate,
  onClone,
  onTogglePreview,
}) => {
  return (
    <Layout
      style={{
        position: "sticky",
        top: 0,
        zIndex: 100,
        width: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        padding: "8px 32px",
        // boxShadow: "0 4px 6px -2px rgba(0, 0, 0, 0.1)",
        borderBottom: `1px solid #e5e7eb`,
      }}
    >
      <Layout.Content
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div className="flex items-center space-x-4">
          <div>
            <div className="flex items-center space-x-2">
              <Typography.Title
                level={5}
                style={{ margin: 0, color: "#6b7280" }}
              >
                Project
              </Typography.Title>
            </div>
            <Typography.Title level={3} style={{ margin: 0 }}>
              {projectName}
            </Typography.Title>
          </div>
        </div>
        <div className="flex items-center gap-3">
          {!isEditing ? (
            <>
              <Button
                type="primary"
                onClick={onEdit}
                icon={<Edit size={16} />}
                className="shadow-sm"
              >
                Edit
              </Button>
              <Button
                type="default"
                onClick={onClone}
                icon={<Copy size={16} />}
                className="shadow-sm"
              >
                Clone
              </Button>
            </>
          ) : (
            <div className="flex items-center gap-2">
              <Button onClick={onCancelEdit} className="shadow-sm">
                Cancel
              </Button>
              <Button
                type="primary"
                onClick={onSave}
                disabled={saving || hasFormErrors}
                loading={saving}
                className="shadow-sm"
                icon={<Save size={16} />}
              >
                {saving ? "Saving..." : "Save Changes"}
              </Button>
            </div>
          )}

          <div className="h-6 w-px bg-gray-300" />

          <Button
            type="default"
            onClick={onValidate}
            loading={validating}
            className="shadow-sm"
          >
            {validating ? "Validating..." : "Validate"}
          </Button>

          <Button
            type={showPreview ? "primary" : "default"}
            onClick={onTogglePreview}
            icon={showPreview ? <EyeOff size={16} /> : <Eye size={16} />}
            className="shadow-sm"
          >
            {showPreview ? "Hide Preview" : "Show Preview"}
          </Button>
        </div>
      </Layout.Content>
    </Layout>
  );
};

export default ProjectHeader;
